import styled from '@emotion/styled';

export const FundingStepContent = styled.div``;
